import { jwtDecode } from "jwt-decode";
import { useCallback, useEffect, useState } from "react";
import { logout as apiLogout } from "../lib/api";

export interface User {
  username: string;
  userId: number;
}

export function useAuth() {
  const [token, setToken] = useState<string | null>(localStorage.getItem("accessToken"));
  const [user, setUser] = useState<User | null>(null);

  const logout = useCallback(async () => {
    await apiLogout().catch(console.error);
  }, []);

  useEffect(() => {
    const sync = () => {
      const newToken = localStorage.getItem("accessToken");
      setToken(newToken);
      if (newToken) {
        try {
          const decoded = jwtDecode(newToken) as User;
          setUser({ username: decoded.username, userId: decoded.userId });
        } catch {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    };

    window.addEventListener("storage", sync);
    sync();
    return () => window.removeEventListener("storage", sync);
  }, []);

  return { token, user, setToken, logout };
}
